export * from '@react-three/fiber';

console.warn('react-three-fiber has been deprecated, please use @react-three/fiber (https://www.npmjs.com/package/@react-three/fiber) from now on');
